import { FC, useEffect, useState } from 'react'
import { GetServerSidePropsContext, NextPage } from 'next'
import { useRouter } from 'next/router'

import {
  GetServerSidePropsReturnType,
  PageProps,
} from '../../relay/Common/PageProps'
import getConfiguration from '../../rest/services/getConfiguration'
import { initWithLangAndLabels } from '../../i18n'
import RestApiClient from '../../rest/client'
import getProfiles from '../../rest/requests/user/getProfiles'
import { UserProfile } from '../../rest/types/UserProfile'
import LoginRegisterTemplate from '../../templates/LoginRegisterTemplate'
import useProps from '../../relay/Auth/useLoginOrRegisterProps'
import { PublicGuard } from '../../guards'
import getSpecialities from '../../rest/requests/user/getSpecialities'
import { UserSpeciality } from '../../rest/types/UserSpeciality'

type Props = PageProps & {
  profiles: Array<UserProfile>
  specialities: Array<UserSpeciality>
  displayLoginFormParam: string | string[]
}

const ConnexionContent: FC<Props> = ({
  configuration,
  profiles,
  specialities,
  displayLoginFormParam,
}) => {
  const props = useProps({
    configuration,
    profiles,
    specialities,
    displayLoginFormParam,
  })
  return <LoginRegisterTemplate {...props} />
}

const Connexion: NextPage<Props> = (props) => {
  const router = useRouter()
  const [resetKey, setResetKey] = useState(0)

  // Navigating to the current URL (header "Connexion") doesn't remount the page, so restart the flow
  useEffect(() => {
    const reset = () => setResetKey((key) => key + 1)
    router.events.on('routeChangeComplete', reset)
    return () => router.events.off('routeChangeComplete', reset)
  }, [router.events])

  return <ConnexionContent key={resetKey} {...props} />
}

export default PublicGuard(Connexion)

export async function getServerSideProps(
  context: GetServerSidePropsContext
): GetServerSidePropsReturnType<Props> {
  const displayLoginFormParam = context?.query?.displayLoginForm ?? ''

  const [configuration, { data: profiles }, { data: specialities }] =
    await Promise.all([
      getConfiguration(),
      await RestApiClient.call(getProfiles()),
      await RestApiClient.call(getSpecialities()),
    ])

  const i18n = initWithLangAndLabels('fr', configuration.translations)

  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  return {
    props: {
      // metas: SeoTransformer(
      //   Router.getRouteUrl(routes.retailer, context?.params),
      // ),
      configuration,
      profiles,
      specialities,
      displayLoginFormParam,
      i18n,
    },
  }
}
